import { RemoteLoadWorkLocationList } from '@/javascript/data/usecases/maps/remote-load-work-location-list'
import { LoadWorkLocationList } from '@/javascript/domain/usecases/maps/load-work-location-list'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '@/javascript/main/factories/http'
import { makeWorkLocationMapper } from '@/javascript/main/factories/mappers'

export const makeRemoteLoadWorkLocationList = (): LoadWorkLocationList =>
  new RemoteLoadWorkLocationList(
    makeApiUrl('/maps/work_locations'),
    makeCurrentAccountHttpClientDecorator(),
    makeWorkLocationMapper()
  )
